import styled from "styled-components";
import { FiInstagram, FiYoutube, FiMessageSquare } from "react-icons/fi"; // Opcional: npm install react-icons

export default function Footer() {
  return (
    <Container>
      <MainContent>
        <BrandSection>
          <Logo>
            <img src="/img/logo.png" alt="V8 Society Logo" />
          </Logo>
          <Description>
            A maior plataforma para entusiastas do mundo automotivo. 
            Fichas técnicas, comparativos e as últimas notícias do setor.
          </Description>
          <SocialIcons>
            <a href="#"><FiInstagram /></a>
            <a href="#"><FiYoutube /></a>
            <a href="#"><FiMessageSquare /></a>
          </SocialIcons>
        </BrandSection>

        <LinksGrid>
          <Column>
            <h4>Navegação</h4>
            <a href="#">Notícias</a>
            <a href="#">Ficha Técnica</a>
            <a href="#">Comparativo</a>
            <a href="#">Loja Oficial</a>
          </Column>

          <Column>
            <h4>Institucional</h4>
            <a href="#">Sobre a V8</a>
            <a href="#">Fale Conosco</a>
            <a href="#">Termos de Uso</a>
            <a href="#">Privacidade</a>
          </Column>

          <Column>
            <h4>Comunidade</h4>
            <a href="#">Instagram</a>
            <a href="#">YouTube</a>
            <a href="#">Discord</a>
            <a href="#">Membros</a>
          </Column>
        </LinksGrid>
      </MainContent>

      <CopyrightBar>
        <p>© 2026 <span>V8 Society</span> — Todos os direitos reservados</p>
        <BackToTop onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          Voltar ao topo ↑
        </BackToTop>
      </CopyrightBar>
    </Container>
  );
}

/* ESTILOS */

const Container = styled.footer`
  width: 100%;
  background-color: #080808;
  color: #fff;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  font-family: 'Inter', sans-serif;
`;

const MainContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 30px;
  display: grid;
  grid-template-columns: 1.2fr 2fr;
  gap: 60px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 60px 20px;
  }
`;

const BrandSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 900px) {
    align-items: center;
  }
`;

const Logo = styled.div`
  img {
    height: 70px;
    filter: drop-shadow(0 0 10px rgba(255, 26, 26, 0.2));
  }
`;

const Description = styled.p`
  color: #888;
  font-size: 14px;
  line-height: 1.6;
  max-width: 300px;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  
  a {
    color: #fff;
    font-size: 20px;
    background: rgba(255, 255, 255, 0.05);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    transition: 0.3s;
    border: 1px solid rgba(255, 255, 255, 0.1);

    &:hover {
      background: #ff1a1a;
      border-color: #ff1a1a;
      transform: translateY(-3px);
      box-shadow: 0 5px 15px rgba(255, 26, 26, 0.3);
    }
  }
`;

const LinksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h4 {
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -5px;
      width: 20px;
      height: 2px;
      background: #ff1a1a;
    }
  }

  a {
    color: #888;
    text-decoration: none;
    font-size: 14px;
    transition: 0.2s;

    &:hover {
      color: #ff1a1a;
      padding-left: 5px;
    }
  }

  @media (max-width: 900px) {
    h4::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const CopyrightBar = styled.div`
  background: #000;
  padding: 25px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.05);

  p {
    font-size: 13px;
    color: #555;
    margin: 0;

    span {
      color: #ff1a1a;
      font-weight: bold;
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
`;

const BackToTop = styled.button`
  background: transparent;
  border: none;
  color: #888;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
  transition: 0.3s;

  &:hover {
    color: #ff1a1a;
  }
`;